import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * @description Hook personalizado para acceder fácilmente al contexto de autenticación (`AuthContext`).
 * Simplifica el uso del contexto, evitando la necesidad de importar `useContext` y `AuthContext` en cada componente que lo necesite.
 * @returns {object} El valor del contexto de autenticación, que incluye `currentUser`, `login` y `logout`.
 */
export const useAuth = () => {
  return useContext(AuthContext);
};